import React from 'react';
import { motion } from 'framer-motion';

const CTASection = () => {
  return (
    <section className="home-cta-section">
      <div className="home-cta-panel">
        <motion.div
          className="home-cta-copy"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.55 }}
        >
          <h2>¿Listo para cotizar tu proyecto?</h2>
          <p>
            Cuéntanos qué necesitas y armamos una propuesta a tu medida.
          </p>
          <div className="home-cta-actions">
            <button
              type="button"
              className="btn-cta"
              onClick={() => {
                window.location.hash = 'contacto';
              }}
            >
              Solicitar cotización
            </button>
            <button
              type="button"
              className="home-cta-secondary"
              onClick={() => {
                window.location.hash = 'productos';
              }}
            >
              Explorar productos
            </button>
          </div>
        </motion.div>
        <motion.div
          className="home-cta-visual"
          initial={{ opacity: 0, x: 24 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          <img
            src="/assets/Images/BOMBOM AZUL - 4 PUNTAS CAFE.jpg"
            alt="Mobiliario VERISSA"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
